/**
 * Created by razial on 18.09.2026.
 */

PassLevelsConfig.salepass = [
    {
        energy: 0,
        task: {
            goal: 30
        },
        reward: {
            unit: { code: "crystal", stage: 0, amount: 1 }
        },
        premiumReward: {
            unit: { code: "crystal", stage: 0, amount: 3 }
        }
    }, // 1
    {
        energy: 5,
        task: {
            goal: 150
        },
        reward: {
            unit: { code: "treasure", stage: 0, amount: 1 },
            stickers2BrownPack: 1
        },
        premiumReward: {
            unit: { code: "treasure", stage: 1, amount: 2 },
            stickers2BluePack: 1
        }
    }, // 2
    {
        energy: 5,
        task: {
            goal: 275
        },
        reward: {
            unit: { code: "coins", stage: 4, amount: 1 }
        },
        premiumReward: {
            unit: { code: "coinscup", stage: 2, amount: 1 }
        }
    }, // 3
    {
        energy: 5,
        task: {
            goal: 325
        },
        reward: {
            unit: { code: "treasure", stage: 1, amount: 1 },
            stickers2BrownPack: 1
        },
        premiumReward: {
            unit: { code: "worker", stage: 4, amount: 2 },
            stickers2BluePack: 1
        }
    }, // 4
    {
        energy: 10,
        task: {
            goal: 355
        },
        reward: {
            unit: { code: "worker", stage: 3, amount: 1 }
        },
        premiumReward: {
            unit: { code: "treasure", stage: 2, amount: 3 }
        }
    }, // 5
    {
        energy: 10,
        task: {
            goal: 400
        },
        reward: {
            unit: { code: "treasure", stage: 2, amount: 1 },
            stickers2GreenPack: 1
        },
        premiumReward: {
            unit: { code: "crystal", stage: 3, amount: 2 },
            stickers2BluePack: 1
        }
    }, // 6
    {
        energy: 10,
        task: {
            goal: 475
        },
        reward: {
            unit: { code: "sacks", stage: 2, amount: 1 }
        },
        premiumReward: {
            unit: { code: "coins", stage: 5, amount: 3 }
        }
    }, // 7
    {
        energy: 15,
        task: {
            goal: 525
        },
        reward: {
            unit: { code: "coins", stage: 3, amount: 1 },
            stickers2GreenPack: 1
        },
        premiumReward: {
            unit: { code: "rubies", stage: 4, amount: 1 },
            stickers2VioletPack: 1
        }
    }, // 8
    {
        energy: 15,
        task: {
            goal: 600
        },
        reward: {
            unit: { code: "worker", stage: 3, amount: 2 }
        },
        premiumReward: {
            unit: { code: "coinstree", stage: 1, amount: 1 }
        }
    }, // 9
    {
        energy: 15,
        task: {
            goal: 750
        },
        reward: {
            unit: { code: "magicplant", stage: 5, amount: 1 },
            stickers2BluePack: 1
        },
        premiumReward: {
            unit: { code: "energytree", stage: 2, amount: 1 },
            stickers2RedPack: 1
        }
    } // 10
];
